import { asArray } from "./map";
import { timeStampToLongString } from "./stringUtils";

export const ramToString = ram => {
  if (!ram) return "";
  const { totalRam, availableRam } = ram;
  if (!totalRam || !availableRam) return "";
  const gb = 1000000000;
  return (
    ((totalRam - availableRam) / gb).toFixed(1) +
    "GB/" +
    (totalRam / gb).toFixed(1) +
    "GB"
  );
};

export const availableStorageToString = storage => {
  if (!storage) return "";
  const gb = 1000000000;
  return (
    (storage / gb).toFixed(1) + "GB"
  );
};

export const bytesToGb = storage => {
  if (!storage) return "";
  const gb = 1000000000;
  return (
    (storage / gb).toFixed(1) + "GB"
  );
};

export const installedAppsToRows = installedApps => {
  let rows = [];
  asArray(installedApps).map(
    ({ applicationName, packageName, versionCode, versionName, lastUpdate }) => {
      rows.push([
        applicationName,
        packageName,
        versionCode,
        versionName,
        timeStampToLongString(lastUpdate)
      ]);
    }
  );
  return rows;
};

export const getDeviceApprovedApps = ({
  deviceGroup: { contentBundleRefs, approvedApps },
  apps,
  contentBundles
}) => {

  let allApprovedApps = {};
  if (contentBundleRefs)
    contentBundleRefs.map(bundle => {
      if (!contentBundles[bundle.id]) return;
      contentBundles[bundle.id].appRefs.map(
        ({ id }) => (allApprovedApps[id] = apps[id])
      );
    });
  if (approvedApps) approvedApps.map(({ id }) => (allApprovedApps[id] = apps[id]));
  return asArray(allApprovedApps);
};
